import { isArray } from 'lodash'
import {
    getConditinalField,
    makeFieldMultiTouch,
    templateField,
} from '../../helpers/slug'
import { ShowField } from './ShowField'

export const ConditionalComponent = ({ item, parentValue, ...props }) => {
    const { isThisMultiTouchProduct, mailerKey, product } = props

    const fields = getConditinalField(item, parentValue, product)

    const prepareMultiTouch = (innerItem) => {
        if (!isThisMultiTouchProduct) return innerItem

        if (innerItem.name === templateField.name) {
            const field = {
                ...innerItem,
                isAttribute: false,
            }
            const fields = [field]
            return fields
        }

        return innerItem
    }

    if (fields.length < 1) return null

    return fields.map((field) => {
        const maxFiles = field?.item?.maxFiles || 1

        if (!field.item) return null

        if (
            isThisMultiTouchProduct &&
            field.item.name === 'Duplicate this order'
        ) {
            return null
        }

        let innerItem = prepareMultiTouch(field.item)

        // const parent_key = item.name
        //         .replace(innerItem.parent_field, '')
        //         .trim()

        innerItem = isArray(innerItem) ? innerItem : [innerItem]

        innerItem = innerItem.map((item) => {
            return {
                ...item,
                name: makeFieldMultiTouch(item.name, mailerKey),
            }
        })

        return innerItem.map((item, idx) => (
            <ShowField
                key={item.name + idx}
                item={item}
                showFiles
                maxFiles={maxFiles}
                {...props}
            />
        ))
    })
}
